import React, { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';

import './SlideOutPanel.scss';
import CloseIcon from '../../assets/template/close.svg';

interface Props {
  open: boolean;
  onClose(): void;
  children: React.ReactNode;
  // For primary menu (right) or potentially decorations drawer (bottom)
  variant?: 'right' | 'bottom';
}

const SlideOutPanel = ({
  open, onClose, children, variant = 'right',
}: Props): React.ReactElement => {
  const elementRef = useRef<HTMLDivElement>(null);
  const history = useHistory();

  function handleClick(e: MouseEvent) {
    const element = e.target as HTMLElement;
    const panelClick = elementRef.current?.contains(element);

    if (panelClick) {
      const { tagName } = element;
      // We self close if a user clicks on a link (menu item) or a button (close)
      const requestClose = ['BUTTON', 'A'].includes(tagName);

      if (requestClose) {
        if (tagName === 'A') {
          const anchor = element as HTMLAnchorElement;
          const { pathname } = anchor;
          history.push(pathname);
        }

        onClose();
      }
    } else {
      onClose();
    }
  }

  useEffect(() => {
    /**
     * Any mouse down in the document, we'll use our reference to see if it happened
     * within or outisde the slide out panel
     */
    document.addEventListener('mousedown', handleClick, false);

    return () => document.removeEventListener('mousedown', handleClick, false);
  }, []);

  const stateClass = open ? 'open' : 'closed';
  const panelClassNames = ['panel', 'box', 'slide-out-panel', variant, stateClass];
  const contentBlockerClassNames = ['slide-out-panel-blocker', stateClass];

  return (
    <>
      <div className={contentBlockerClassNames.join(' ')} />

      <div className={panelClassNames.join(' ')} ref={elementRef}>
        <button className="button secondary icon-button close" type="button" onClick={onClose}>
          <img src={CloseIcon} className="icon" alt="Close panel" />
        </button>

        { children }
      </div>
    </>
  );
};

export default SlideOutPanel;
